"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Whisper = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@twurple/common");
const ircv3_1 = require("ircv3");
const ChatUser_1 = require("../../../ChatUser");
const emoteUtil_1 = require("../../../utils/emoteUtil");
/** @private */
let Whisper = class Whisper extends ircv3_1.Message {
    get userInfo() {
        return new ChatUser_1.ChatUser(this._prefix.nick, this._tags);
    }
    get emoteOffsets() {
        return (0, emoteUtil_1.parseEmoteOffsets)(this._tags.get('emotes'));
    }
    parseEmotes() {
        const messageText = this.params.message;
        const foundEmotes = (0, emoteUtil_1.parseEmotePositions)(messageText, this.emoteOffsets);
        return (0, common_1.fillTextPositions)(messageText, foundEmotes);
    }
};
tslib_1.__decorate([
    (0, ircv3_1.MessageParamDefinition)()
], Whisper.prototype, "target", void 0);
tslib_1.__decorate([
    (0, ircv3_1.MessageParamDefinition)({
        trailing: true,
        optional: true
    })
], Whisper.prototype, "message", void 0);
Whisper = tslib_1.__decorate([
    (0, ircv3_1.MessageType)('WHISPER')
], Whisper);
exports.Whisper = Whisper;
